import { LargeText } from "@/components/typography/Typography";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import axios from "axios";
import { Loader } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

export default function AddBookingComHotel() {
  const [url, setUrl] = useState<string>("");
  const [bookingId, setBookingId] = useState<number>();
  const [status, setStatus] = useState<"loading" | "success" | "failed" | null>(
    null
  );

  const onClick = useCallback(async () => {
    if (!bookingId) return;
    setStatus("loading");

    const url = `${import.meta.env.VITE_DS_BACKEND_URI}/directsearch/download`;

    try {
      const res = await axios.get(url, {
        params: { bookingId },
      });

      if (res.status === 201) setStatus("success");
      else setStatus("failed");
    } catch {
      setStatus("failed");
    }
  }, [bookingId]);

  useEffect(() => {
    if (url) {
      // https:www.booking.com/hotel/it/towers-hotel.it.html?aid=304142&label=gen173nr-1FCAEoggI46AdIM1gEaHGIAQGYARS4AQfIAQzYAQHoAQH4AQyIAgGoAgO4AvjbwcEGwAIB0gIkNTJhYzQ0ZGQtOTM2YS00MTc3LThmNjktYjU5OWRkYTZhYmQx2AIG4AIB&sid=c583a2aa8313594c571ac3c6101eb4c8&all_sr_blocks=8090227_0_2_1_0&checkin=2025-06-16&checkout=2025-06-17&dest_id=80902&dest_type=hotel&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=8090227_0_2_1_0&hpos=1&matching_block_id=8090227_0_2_1_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=8090227_0_2_1_0__14119&srepoch=1748004357&srpvid=b70559c1bf4b0146&type=total&ucfs=1&
      const all_sr_blocks = url.match(/all_sr_blocks=([0-9]+)/);
      const bookingId = all_sr_blocks?.[1].slice(0, -2);
      setBookingId(Number(bookingId));
    }
  }, [url]);

  return (
    <div className="flex flex-col gap-5 ">
      <div className="flex flex-col gap-2">
        <LargeText>Booking.com URL</LargeText>
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https:www.booking.com/hotel/it/nome-hotel.it.html?aid=...&all_sr_blocks=123456789_0_2_1_0&..."
        />
      </div>
      <div className="w-64 flex flex-col gap-2">
        <LargeText>Booking.com ID</LargeText>
        <Input
          type="number"
          value={bookingId}
          onChange={(e) => setBookingId(Number(e.target.value))}
        />
      </div>
      {status === "loading" ? (
        <Loader />
      ) : status === "success" ? (
        <div>Hotel downloaded successfully</div>
      ) : status === "failed" ? (
        <div>Failed to download hotel</div>
      ) : (
        <Button onClick={onClick}>Add hotel</Button>
      )}
    </div>
  );
}
